<template>
<div class="p-3 border-fuchsia-200 border-l-4 bg-gray-50">
  
  <prismic-rich-text v-if="this.title" class="m-auto font-bold text-xl text-fuchsia-500 h-24 pb-4" :field="title"/>
  
  <img v-if="this.image.url" v-bind:src="this.image.url" class="mb-8 cursor-pointer object-cover h-56 ring-gray-200 ring-2"  v-on:click="openModal()"/>
  
  <div v-if="transcriptVideoShow" class="pb-3 space-y-1">
    <youtube :fitParent="true" :video-id="transcriptVideoId" ref="transcriptYoutube"></youtube>
  </div>
  
  <prismic-rich-text class="m-auto mb-4 text-lg leading-relaxed" :field="body"/>
  
  <prismic-rich-text v-if="this.context" class="m-auto font-bold text-xl text-fuchsia-500 " :field="context"/>
  
  <prismic-link v-if="this.plainLink " :field="link"  class="flex justify-center m-auto">
    <ButtonMore />
  </prismic-link>
  
  
  <div name="debug" class="hidden">
    {{plainLink}} -- {{transcriptVideoId}}
  </div>
  
  
  <div id="image-modal" v-show="modalShow"  class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center">

    <div v-on:click="closeModal()" class="modal-overlay cursor-pointer absolute w-full h-full bg-gray-900 opacity-50"></div>

    <div class="modal-container bg-white cursor-pointer w-auto shadow-sm z-50">
      <div v-on:click="closeModal()"  class="cursor-pointer modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
        <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
        </svg>
      </div>
      
      <div class="modal-content text-left p-2">
        <div class="">
          <img v-on:click="closeModal()" class="" :src="this.image.url" />
        </div>
          
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ButtonMore from './ButtonMore.vue'

export default {
    name: 'MediaTile',
    components:{
        ButtonMore
    },
    data() {
        return {
            modalShow: false,
            transcriptVideoId: null,
            transcriptVideoShow: false,
            plainLink: null
        }
    },
    props: {
        title: Array,
        body: Array,
        image: Object,
        quote: Boolean,
        context: String,
        link: Object
    },
    methods: {
        closeModal() {
            this.modalShow = false;
        },
        openModal() {
            this.modalShow = true
    },
        extractYoutubeId(p) {
            return this.$youtube.getIdFromUrl(p)
        },
        checkTranscriptVideo(){
            if(this.link.url){
                var longUrl = this.link.url;
                var shortId = this.extractYoutubeId(longUrl);
                
                if(shortId){
                    console.log(`MediaTile: Got transcript video id - ${shortId}`)
                    this.transcriptVideoId = shortId;
                    this.transcriptVideoShow = true;
                }else{
                    console.log(`MediaTile: Got a link, but not youtube, leaving alone`)
                    this.plainLink = longUrl;
                }
            }
        }
    },
    created(){
        this.checkTranscriptVideo();
    }

}
</script>
